<template>
   <div id="inside" style="" :style="largura > 500 ? 'min-height: 685px;': 'min-height: 480px;'">
     
    <div class="container">
      <div class="row">
        <div class="">
        </div>
        <div class="btn-group btn-group-sm">
            <a
              href="/"
              class="btn btn-link d-flex flex-column justify-content-center text-secondary"
              ><i class="fa fa-home fa-fw fa-lg"></i
            ></a>
            <router-link
              to="/dashboard/negociarDivida"
              ><a class="btn btn-link text-secondary">Negociar Dívidas</a>
            </router-link>
            <router-link
              to="#"
              ><a href="#" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Negociar</a>
            </router-link>
        </div>
        <div class="col-md-12">
            <h1>Negociar</h1>
            <div class="row justify-content-between align-items-center col-12">
              <p class="text-muted">Confira os contratos e selecione a opção desejada.</p>
              <button v-if="!loadDeal" type="button" style="background-color: #23546d;" 
              class="float-left btn text-white btn-lg btn-block col-6 col-md-2"
              @click="voltar()">Voltar</button>
            </div>
        </div>
        
      </div>
        <div class="d-inline-flex flex-column col-acao col-lg-12" v-if="thereIsContractSecondInvoice" style="margin-top: 25px;">
          <p class="text-danger m-0" v-if="numberContractsRemoved < 2"> {{ numberContractsRemoved }} contrato foi removido.</p>
          <p class="text-danger m-0" v-if="numberContractsRemoved > 1"> {{ numberContractsRemoved }} contrato(s) foram removidos.</p>
          <p class="text-danger m-0"> Não é possível realizar acordo com contrato(s) que devem gerar segunda fatura de imediato.</p><br>
        </div>
        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-12">
          <!-- v-for="(value, key, index) in contract"
          :key="`${key}-${index}`"> -->     
          <div class="card col-12 ml-0">
            <div class="card-body border-top-0">
              <div class="row col-12">
                  <h6 class="">Contratos selecionados</h6>
              </div>
              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="table-responsive">
                    <table class="table table-sm" width="100%" cellspacing>
                      <thead class="">
                        <tr class="small">
                          <th v-if="!isMobile()">Contrato</th>
                          <th>Valor original (R$)</th>
                          <th v-if="!isMobile()">Parcelas Selecionadas</th>
                          <th>Valor atualizado</th>
                          <th width="10%"></th>
                        </tr>
                      </thead>
                      <tbody class="text-muted">
                        <tr v-for="(value, key, index) in contracts"
                          :key="`${key}-${index}`">
                          <!-- <pre>{{ value.contrato }}</pre> -->
                          <td v-if="!isMobile()">{{ value.contrato }}</td>
                          <td>{{ sumByContract(value) }}</td>
                          <td v-if="!isMobile()">{{ installmentOption ? 'Todas' : value.parcelas.length }}</td>
                          <td>R$  {{ totalByContract[value.contrato] ? totalByContract[value.contrato].RETORNO.VALORTOTAL :
                          responseFromOffers ? responseFromOffers.RETORNO.VALORTOTAL : "- - , - -" }}</td>
                          <!-- <pre> {{ value }} </pre> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row">
              </div>
              <br>
              <div class="col-md-12" v-if="agreementClosed">
                <p class="small">Status do acordo: Aceito.</p> 
              </div>
              <div class="row" v-if="!loadDeal && !agreementClosed">
                  <div class="col-12 col-md">
                    <p class="" v-if="dateSelected === '' && changeDate">Selecione uma data para pagamento:</p>
                    <p class="" v-if="dateSelected != ''">Data selecionada: {{ formatData(dateSelected.toJSON().split("T")[0], "YYYY-MM-DD", "L") }}</p>
                    <datepicker id="datepicker" class="form-control inrad" :language="ptBR" v-if="!loadDeal && changeDate" placeholder="dd/mm/aaaa" v-model="dateSelected" :disabled-dates="state.disabledDates"></datepicker> 
                    <button v-if="dateSelected != '' && !changeDate" type="button" style="background-color: #23546d;" 
                    class="btn text-white btn-lg col-12 col-md-7 col-lg-6 mb-4 mb-md-0"
                    @click="refresh()">Alterar opções de negociação</button>
                  </div>
                  <div class="row col">
                    <div class="col-lg-5">
                      <!-- :class="installmentOption ? 'offset-5 col-6' : 'offset-8 col-6'" -->
                      <div class="col-lg-12" v-if="dateSelected && installmentOption && !isUpdatedParc && !isUpdated">
                        <input
                          type="radio" 
                          value="parc"
                          id="parc"
                          v-if="installmentOption"
                          name="parcOrvista" 
                          v-model="parcOrvista"
                        />
                        <label class="ml-1" for="parc">Parcelado</label>
                      </div>
                      <div class="col-lg-12" v-if="dateSelected && installmentOption && !isUpdatedParc && !isUpdated">
                        <input
                          type="radio"
                          value="vista"
                          id="vista"
                          name="parcOrvista"
                          v-model="parcOrvista"
                        />
                        <label class="ml-1" for="vista">A vista</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-7">
                      <button v-if="(!loadDeal && dateSelected != '' && !isUpdated && parcOrvista === 'vista')" 
                        type="button" 
                        style="background-color: #45c7a2;" 
                        class="btn text-white btn-lg col-md-10 col-lg-8 mt-4"
                        @click="resumoAcordo()">Simular à vista</button>
                      <div v-if="(!loadDeal && dateSelected != '' && !isUpdated && !isUpdatedParc && parcOrvista === 'parc')" 
                      type="text"
                      class="" >
                        <div class="col-12">
                          <p class="mb-0" style="font-size: 0.7rem;">Valor de entrada:</p>
                          <input
                            class="form-control col-10" 
                            placeholder="Valor de Entrada" 
                            id="inputval" 
                            v-model.lazy="inputValue"
                            v-model="inputValue"
                            v-money="money"                    
                          />
                        </div>
                      </div>
                      <div class="dropdown col-lg-12"
                      v-if="(!loadDeal && dateSelected != '' && !isUpdated && !isUpdatedParc && parcOrvista === 'parc')" >
                        <a class="btn btn-lg btn-secondary dropdown-toggle text-white mt-2" href="#" 
                        role="button" 
                        id="dropdownMenuLink" 
                        style="background-color: gray; border: none;"
                        data-toggle="dropdown" 
                        aria-haspopup="true" 
                        aria-expanded="false">
                          {{installmentNumber}}
                        </a>
                        <div class="dropdown-menu" 
                        aria-labelledby="dropdownMenuLink"
                        style="max-height: 15rem; overflow-y: auto;">
                          <a class="dropdown-item" 
                          v-for="(numb, key, index) in listInstallmentOptions" 
                          :key="`${key}-${index}`"
                          @click="setInstallmentNumber(numb)">{{numb}}</a>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <button
                          type="button" 
                          style="background-color: #45c7a2;" 
                          v-if="(!loadDeal && dateSelected != '' && !isUpdated && !isUpdatedParc && parcOrvista === 'parc')" 
                          class="btn text-white btn-lg col-md-10 col-lg-12 mt-4"
                          @click="resumoAcordoParcelado()">Simular parcelamento</button>
                      </div>
                      <button v-if="!isUpdatedParc && isUpdated"
                        type="button" 
                        style="background-color: #45c7a2;" 
                        class="btn text-white btn-lg col-12 col-lg-10 col-md-8 offset-md-3 offset-lg-0"
                        @click="negociarAcordos()">Aceitar negociação
                      </button>
                    </div>
                  </div>
                  <ProgressLoading v-bind:loading="loadDeal" />
                </div>
                
                <div class="container" v-if="loadDeal">
                  <ProgressLoading v-bind:loading="loadDeal" />
                </div>
            </div>
          </div>
          <div class="card col-12 ml-0" v-if="isUpdatedParc">
            <div class="card-body border-top-0 row">
              <div class="col-12 mb-3">
                  <h5 class="">Confira as condições para parcelamento</h5>
              </div>
              <br>
              <div class="row col-12 align-items-end">
                <div class="col-12 col-md-8">
                  <div class="col-12">
                    <div class="table-responsive" :style="!responseFromOffers['PARCELAS'].length > 5 ? '' : 'height: 12rem; overflow'">
                      <table class="table table-sm" width="100%" cellspacing>
                        <!-- v-if="isUpdatedParc" -->
                        <thead class="justify-content-around" v-if="isUpdatedParc">
                          <tr class="small">
                            <th>Número da parcela</th>
                            <th>Valor da parcela</th>
                            <th width="10%"></th>
                          </tr>
                        </thead>
                        <tbody class="text-muted" v-if="isUpdatedParc">
                          <tr v-for="(value, key, index) in responseFromOffers['PARCELAS']"
                            :key="`${key}-${index}`">
                            <td>{{ value.PARCELA === '000' ? 'entrada': value.PARCELA }}</td>
                            <td>R$ {{ value.PAGO }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="col-12 mt-4">
                    <h5 style="text-align: center;" class="">Número de parcelas</h5>
                    <h5 style="text-align: center;">{{ responseFromOffers['PARCELAS'].length }}</h5>
                  </div>
                  <div class="col-12 mt-5">
                    <h6 style="text-align: center;" class="">1 x de R${{ responseFromOffers['PARCELAS'][0]['PAGO'] }}</h6>
                    <h6 style="text-align: center;" class="">+</h6>
                    <h6 style="text-align: center;">{{ responseFromOffers['PARCELAS'].length - 1 }}x de R${{ responseFromOffers['PARCELAS'][1]['PAGO'] }}</h6>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="row" style="margin: 0px 25px 15px;">
              <div class="col-7">

              </div>
              <div class="col-5">
                <button v-if="isUpdatedParc"
                      type="button" 
                      style="background-color: #45c7a2;" 
                      class="float-right btn text-white btn-lg col-12 col-lg-8 col-md-8 mt-3 offset-md-3 offset-lg-0"
                      @click="negociarAcordos()">Aceitar negociação
                    </button>
              </div>

            </div>
          </div>
    </div>
    </div>
    
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencieValueBRL as formatValue, formatData } from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import {VMoney} from 'v-money'
import { en, ptBR } from "vuejs-datepicker/dist/locale";


export default {
    name: "HistoricoPagamentos",
     components: {
       ProgressLoading,
       Datepicker
    },
    directives: {
      money: VMoney
    },
    data () {
        return {
          currentDate: null,
          datePlusFive: null,
          currentYear: null,
          currentMonth: null,
          currentDay: null,
          state: null,
            monthNames : ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
              "Jul", "Ago", "Set", "Out", "Nov", "Dez"
            ],
            loadDeal: false,
            dateSelected: '',
            price: '123.50',
            money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              suffix: '',
              precision: 2,
              masked: false /* doesn't work with directive */
            },
            // price: 123.45,
            // money:  {
            //   decimal: ',',
            //   thousands: '.',
            //   prefix: 'R$ ',
            //   suffix: '',
            //   precision: 2,
            //   masked: false
            // },
            listInstallmentOptions: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
            validatorValue:'',
            eventCount:0,
            parcOrvista: 'vista',
            showRemoveContract:false,
            isUpdatedParc: false,
            negociacao: null,
            inputValue: null,
            isUpdated: false,
            contractsShowed:[],
            totalByContract: {},
            expandSelect: false,
            arrayToCall: [],
            contract :null,
            responseFromOffers:null,
            selectDeal:null,
            digitalLine:null,
            contractFull: null,
            allContracts : null,
            checkSelectAll: false,
            lastFilterValue:0,
            checkContract: false,
            expiredDate: new Date().toISOString().slice(0,10),
            links: [],
            changeDate: true,
            agreementClosed: false,
            installmentNumber: 'Número de parcelas',
            largura: null,
            thereIsContractSecondInvoice: false,
            numberContractsRemoved: 0,
            ptBR: ptBR,
            en: en,
            userAdm: {},
            ipUser: null
        }
    },
    methods: {
        formatValue,
        formatData,

        ...mapActions('minhasDividas', 
          [
            'ActionGetOffersTribanco',
            'ActionSetAgreement'
          ]
        ),

        isMobile() {
          if(parseInt(this.largura) > 500) return false
          return true
        },

        setInstallmentNumber(numb) {
          this.installmentNumber = numb
        },

        deactivated() {
            this.divida = null;
            this.negociacao = null;
            this.selectDeal = null;
            this.digitalLine = null;
        },
        voltar() {
             this.$router.push({ name: 'dashboard' });
        },
        showDigitalLine(){
          this.digitalLine = this.selectDeal.linhaDigitavel;
        },

        selectAll() {
              var marcar = document.getElementById('all').checked;
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = marcar;
              }
        },

        select() {
          var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
          var all = document.getElementById('all');
          if(lista.length <= 2) {
            all.checked = false;
          }
        },

        clear() {
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = false;
              }
        },

        calcDay(dateStr,isDate){
          const date = new Date(dateStr);
          if(isDate)
            return date;

          return date.getDate().toString().padStart(2, "0") + '/' + this.monthNames[date.getMonth()];
        },

        async resumoAcordoParcelado() {

          let valueInputSend =  String(parseFloat(this.inputValue.replace('R$ ', '').replace(/\./g, '').replace(',', '.')))
          if (valueInputSend < 5) {
            this.flashMessage.show({
              status: 'error',
              position:'top', 
              blockClass: 'custom-block-class',
              title: 'Erro', 
              message: 'Valor de entrada inválida'});
            return
          }
          this.loadDeal = true;
          this.changeDate = false;
          this.isUpdated = false;

          try {
            const allContracts = JSON.parse(localStorage.getItem('contracts'))
            this.arrayToCall = [];
            for(const contract of this.contracts) {
              allContracts.map((value) => {
                if (value.contrato === contract.contrato) {
                  let thisContract = { 
                    document: value.regis,
                    credor: value.credor,
                    company: value.company, 
                    inputValue: valueInputSend.replace('.', ',') || "0",
                    installmentNumber: String(this.installmentNumber),
                    installments: [],
                    dueDate: this.dateSelected.toJSON().split("T")[0],
                    tag: localStorage.getItem('tag') 
                  }
                  value.parcelas.map((installment) => {
                    if (JSON.stringify(this.contracts.filter(value => {
                      return value.contrato === contract.contrato
                    })[0].parcelas).includes(JSON.stringify(installment))) {
                      thisContract.installments.push({
                        contract: value.contrato,
                        product: value.produto,
                        dueInstallmentDate: installment.vencimento
                      })
                    }
                  })
                  this.arrayToCall.push(thisContract);
                }
              })
            }
            let reqAgreement = { ...this.arrayToCall[0], installments: [] }
            for (const req of this.arrayToCall) {
              req.installments.map((installment) => reqAgreement.installments.push(installment))
            }
            reqAgreement.UserID = this.userAdm ? this.userAdm.UserID : null; 
            reqAgreement.UserFullName = this.userAdm ? this.userAdm.UserFullName : null; 
            reqAgreement.OS = navigator.platform; 
            reqAgreement.IP = this.ipUser ? this.ipUser : '',
            this.responseFromOffers = await this.ActionGetOffersTribanco(reqAgreement);
            
            this.loadDeal = false;
            this.isUpdatedParc = true
          } catch {
            this.loadDeal = false;
            this.isUpdated = !this.isUpdated
          }
        },

        async negociarAcordos() {
          this.loadDeal = !this.loadDeal;

          localStorage.removeItem('contracts');
          localStorage.removeItem('selectedContracts');
          localStorage.removeItem('selectedContractsToUpdate');
          try {
            let reqAgreement = { ...this.arrayToCall[0], installments: [], source: 1 }
  
            for (const req of this.arrayToCall) {
              req.installments.map((installment) => reqAgreement.installments.push(installment))
            }

            reqAgreement.UserID = this.userAdm ? this.userAdm.UserID : null; 
            reqAgreement.UserFullName = this.userAdm ? this.userAdm.UserFullName : null; 
            reqAgreement.OS = navigator.platform;
            reqAgreement.IP = this.ipUser ? this.ipUser : '',
            this.responseFromBoleto = await this.ActionSetAgreement(reqAgreement);
            
            this.loadDeal = !this.loadDeal
            this.$router.push({
              name: "acordoFechado",
              params: { responseFromAgreement: this.responseFromBoleto },
            });
          } catch {
            this.loadDeal = !this.loadDeal 
          }
        },

        refresh() {
          this.changeDate = this.changeDate ? false : true;
          this.isUpdated = false;
          this.isUpdatedParc = false;
          this.totalByContract = {};
          // this.totalByContract[key].RETORNO.VALORTOTAL;
        },

        async resumoAcordo() {

          this.loadDeal = true;
          this.changeDate = false;
          this.isUpdated = false;

          try {
            const allContracts = JSON.parse(localStorage.getItem('contracts'))
            this.arrayToCall = []
            for(const contract of this.contracts) {
              allContracts.map((value) => {
                if (value.contrato === contract.contrato) {
                  let thisContract = { 
                    document: value.regis,
                    credor: value.credor,
                    company: value.company, 
                    inputValue: "0",
                    installmentNumber: "0",
                    installments: [],
                    dueDate: this.dateSelected.toJSON().split("T")[0],
                    tag: localStorage.getItem('tag')
                  }
                  value.parcelas.map((installment) => {
                    if (JSON.stringify(this.contracts.filter(value => {
                      return value.contrato === contract.contrato
                    })[0].parcelas).includes(JSON.stringify(installment))) {
                      thisContract.installments.push({
                        contract: value.contrato,
                        product: value.produto,
                        dueInstallmentDate: installment.vencimento
                      })
                    }
                  })
                  this.arrayToCall.push(thisContract);
                }
              })
            }
            
            for (const req of this.arrayToCall) {
              req.UserID = this.userAdm ? this.userAdm.UserID : null; 
              req.UserFullName = this.userAdm ? this.userAdm.UserFullName : null; 
              req.OS = navigator.platform;
              req.IP = this.ipUser ? this.ipUser : '',
              this.totalByContract[req.installments[0].contract] = await this.ActionGetOffersTribanco(req)           
              
            }

            // await this.delay(10000);
            this.isUpdated = !this.isUpdated
            this.loadDeal = false;
          } catch {
            this.loadDeal = false;
          }
        },

        delay(time) {
          return new Promise(resolve => setTimeout(resolve, time));
        },

        async checkValueChange(event,item){
            this.validatorValue = '';
            if(item.Entrada < item.ValorEntradaMinimo && item.Entrada > 0){
              this.validatorValue = 'valor de entrada menor que o permitido';
              return;
            }

            if(item.Entrada > item.ValorEntradaMaximo){
              this.validatorValue = 'valor de entrada maior que o permitido';
              return;
            }
            
            if(this.lastFilterValue != item.Entrada){
              let selected = this.parcelamentSelected;
              selected.EntryValue = item.Entrada;
              this.ActionSetParcelamentSelected(selected);
              /*this.parcelamentSelected = item;*/
              this.lastFilterValue = item.Entrada;
              await this.delay(700);           
              await this.refreshValues();
            }           

        },

        changeExpireDate(filterDate){
          //this.expiredDate = filterDate.toISOString().slice(0,10);
          let selected = this.parcelamentSelected;
          selected.ExpiredDate = filterDate.toISOString().slice(0,10);

          this.ActionSetParcelamentSelected(selected);

          this.refreshValues();
        },

        isChecked(currentDate){
            var date = new Date(this.parcelamentSelected.ExpiredDate);

            if(date.toISOString().slice(0,10) == currentDate.toISOString().slice(0,10))
              return true;
            return false;
        },

        async removeContract(number){
          let contracts =  this.contractNegotiable;
          contracts[contracts.findIndex(v => v.NumeroContrato === number)].selected = false;

          this.ActionSetContractsNegotiable(contracts);
          await this.refreshValues();
        },

        async refreshValues(){
          var contracts = [];

          this.contractNegotiable.filter((f)=> f.selected).forEach((ctr) =>{
            let parcelas = ctr.Parcelas.filter((filter) => filter.selected == true).map((i)=> { return i.NumeroParcela});

            if(ctr.Parcelas.filter((filter) => filter.selected == true).length == ctr.Parcelas.length)
              parcelas = []; 

            contracts.push({
              "NumeroContrato": ctr.NumeroContrato,
              "Parcelas": parcelas
            });
          });
        
          this.loadDeal = true;
          if(this.parcelamentSelected == null)
            this.ActionSetParcelamentSelected({'ExpiredDate':new Date().toISOString().slice(0,10),'NumeroParcela':5 });


          var payload = {
            "DataVencimento":this.parcelamentSelected.ExpiredDate,
            "TipoNegociacao": this.contractNegotiable.filter((f)=> f.selected)[0].TipoNegociacao,
            "Contratos": contracts,
            "Entrada": 0,
          };

          if(this.parcelamentSelected != null && this.parcelamentSelected.EntryValue > 0)
            payload['Entrada'] = this.parcelamentSelected.EntryValue;

          var result =  await this.ActionGetContractsNegotiableOptions(payload);
          
          this.loadDeal = false;
          if (result.status == 500){
            this.flashMessage.show({
                        timeout:300,
                        status: 'error',
                        position:'top', 
                        blockClass: 'custom-block-class',
                        title: 'Erro', 
                        message: result.data.message});
          }else{
            this.showRemoveContract = contracts.length>1;
            this.contractsShowed = this.contractNegotiableOptions.FormasPagamento;
          }
        },

        sumByContract(value) {
          let total = 0
          value.parcelas.map((parcela) => {
            total += parseFloat(parcela.valor.replace('.', '').replace(',', '.'), 10)
          })
          return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace("-","")
        },
        
    },
    async created() {
      this.ipUser = localStorage.getItem('ipUser');
      this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
      this.currentDate = new Date();
      this.currentYear = this.currentDate.getFullYear();
      this.currentDay = this.currentDate.getDate();
      this.currentMonth = this.currentDate.getMonth();

      this.datePlusFive = new Date(this.currentDate.setDate(this.currentDate.getDate() + 6));
      this.datePlusFiveYear = this.datePlusFive.getFullYear();
      this.datePlusFiveDay = this.datePlusFive.getDate();
      this.datePlusFiveMonth = this.datePlusFive.getMonth(); 

      this.state = {
        disabledDates: {
          to: new Date(this.currentYear, this.currentMonth, this.currentDay),
          from: new Date(this.datePlusFiveYear, this.datePlusFiveMonth, this.datePlusFiveDay),
          // days: [6, 0],
        }
      },

      this.largura = window.screen.width; 
      this.loadDeal = true;
      this.contracts = this.$route.params.contracts;
      this.allContracts = this.$route.params.allContracts;
      this.installmentOption = this.$route.params.installmentOption;
      this.onlyContractsSecondInvoice = this.$route.params.onlyContractsSecondInvoice;


      this.contracts.map((listItem) => {
        if(listItem.secondInvoice) {
          this.thereIsContractSecondInvoice = true;
          let index = this.contracts.indexOf(listItem);
          this.contracts.splice(index, 1);
          this.numberContractsRemoved++;
        }
      });

      this.loadDeal = false;
    },
    computed: {
      ...mapState("auth", ["user"]),
      ...mapState("minhasDividas", ["contractNegotiable","agreementResume","contractNegotiableOptions","parcelamentSelected"]),
      isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    }
};
</script>
<style scoped>

.vdp-datepicker {
  max-width: 25%;
  border: 2px;
}


</style>
